import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from '@reduxjs/toolkit'

// Import slices
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  version: 1, // Increment version to clear old state
  whitelist: ['auth', 'ui'] // Persist auth, ui, and condo
}

const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    }),
  devTools: import.meta.env.NODE_ENV !== 'production'
})

export const persistor = persistStore(store)

